import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "KeywordHelperContainer"
}
const _hoisted_2 = {
  key: 0,
  class: "KeywordHelperContent"
}
const _hoisted_3 = { class: "KeywordHelperImportant" }
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = {
  key: 1,
  class: "KeywordHelperContent"
}
const _hoisted_6 = { class: "KeywordHelperImportant" }
const _hoisted_7 = {
  key: 2,
  class: "KeywordHelperContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.helperContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.helperContent.type === _ctx.KeywordHelperType.WRONG_PORTAL)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _cache[1] || (_cache[1] = _createTextVNode(" If you are looking for a ", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.helperContent.degreeType), 1 /* TEXT */),
              _cache[2] || (_cache[2] = _createTextVNode(" degree, check out ", -1 /* CACHED */)),
              _createElementVNode("a", {
                href: _ctx.helperContent.url,
                title: _ctx.helperContent.urlTitle,
                class: "KeywordHelperImportant"
              }, _toDisplayString(_ctx.helperContent.urlTitle), 9 /* TEXT, PROPS */, _hoisted_4)
            ]))
          : (_ctx.helperContent.type === _ctx.KeywordHelperType.BE_MORE_SPECIFIC)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _cache[3] || (_cache[3] = _createTextVNode(" All programmes here are ", -1 /* CACHED */)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helperContent.degreeType), 1 /* TEXT */),
                _cache[4] || (_cache[4] = _createTextVNode(" degrees, try something more specific. ", -1 /* CACHED */))
              ]))
            : (_ctx.helperContent.type === _ctx.KeywordHelperType.ENGLISH_COURSE)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[5] || (_cache[5] = [
                  _createTextVNode(" All listed programmes are taught in ", -1 /* CACHED */),
                  _createElementVNode("span", { class: "KeywordHelperImportant" }, " English, ", -1 /* CACHED */),
                  _createTextVNode(" try something more specific! If you need a language course, we have those on ", -1 /* CACHED */),
                  _createElementVNode("a", {
                    class: "KeywordHelperImportant",
                    href: "https://www.shortcoursesportal.com",
                    title: "Shortcoursesportal.com"
                  }, " Shortcourseportal.com ", -1 /* CACHED */)
                ])))
              : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: "KeywordHelperCloseContainer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismissHelper')))
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "lnr-cross closeIcon" }, null, -1 /* CACHED */)
        ]))
      ]))
    : _createCommentVNode("v-if", true)
}